import { render } from "./DeepPeformanceConfiguration.vue?vue&type=template&id=0795a780&scoped=true&ts=true"
import script from "./DeepPeformanceConfiguration.vue?vue&type=script&lang=ts"
export * from "./DeepPeformanceConfiguration.vue?vue&type=script&lang=ts"

import "./DeepPeformanceConfiguration.vue?vue&type=style&index=0&id=0795a780&scoped=true&lang=css"
import "./DeepPeformanceConfiguration.vue?vue&type=style&index=1&id=0795a780&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0795a780"]])

export default __exports__